<template>
  <div class="data-management">
    <div class="main">
      <div class="table-filter tuolele-main-box">
        <div class="add-data fn-clear">
          <div class="add-btn fn-right">
            <el-button type="primary" @click="addArticle">新增资料</el-button>
          </div>
        </div>
        <div class="filter-form">
          <div class="form-row">
            <div class="form-input">
              <span>内容搜索</span>
              <el-input
                v-model="filterObj.title"
                size="large"
                placeholder="请输入查询内容"
              />
            </div>
          </div>
          <div class="form-row flex-wrap">
            <div class="form-input">
              <span>选择分类</span>
              <el-cascader
                :options="optionsCascader"
                :props="{
                  value: 'id',
                  label: 'directory_name',
                  children: '_child',
                  expandTrigger: 'hover',
                  checkStrictly: true
                }"
                :show-all-levels="false"
                @change="changeDataType"
              />
            </div>
            <div class="form-input">
              <span>内容类型</span>
              <el-select v-model="filterObj.type" placeholder="请选择">
                <el-option
                  v-for="item in optionsContent"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="form-input">
              <span>推荐状态</span>
              <el-select v-model="filterObj.is_recommend" placeholder="请选择">
                <el-option
                  v-for="item in optionsRecommend"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="form-input">
              <span>发布状态</span>
              <el-select v-model="filterObj.is_show" placeholder="请选择">
                <el-option
                  v-for="item in optionsShow"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">适用时段</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="times"
                  :select-list="time_frame"
                  @updateCheck="updateCheck"
                />
              </div>
            </div>
          </div>
          <div class="form-row">
            <el-button type="primary" @click="searchData">查询</el-button>
          </div>
        </div>
      </div>
      <div class="table-main">
        <div class="table-header fn-clear">
          <div class="fn-right table-header-right">
            <el-pagination
              :current-page.sync="filterObj.p"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="filterObj.limit"
              layout="sizes, prev, slot, next"
              prev-text="上一页"
              next-text="下一页"
              :total="itemTotal"
              @size-change="handleSizeChange"
            >
              <div class="chax">
                {{ filterObj.p }}/{{
                  itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
                }}
              </div>
            </el-pagination>
          </div>
        </div>
        <div class="table-body">
          <el-table
            :data="itemList"
            border
            stripe
            :header-cell-style="{
              background: '#4c84ff',
              color: '#fff',
              height: '60px',
              textAlign: 'center'
            }"
            @sort-change="tableSort"
          >
            <el-table-column
              prop="id"
              label="内容ID"
              align="center"
              sortable="custom"
            />
            <el-table-column prop="cover" label="封面" align="center">
              <template slot-scope="scope">
                <img
                  :src="`${scope.row.cover}?imageMogr2/thumbnail/127x`"
                  alt
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="内容标题"
              align="center"
            />
            <el-table-column prop="time_frame" label="使用时段" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.time_frame_array.join("，") }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="directory_list"
              label="关联分类"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.directory_list.join("，") }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="内容类型" align="center">
              <template slot-scope="scope">
                <span v-text="scope.row.type == '1' ? '图文' : '视频'" />
              </template>
            </el-table-column>
            <el-table-column
              prop="is_recommend"
              label="推荐状态"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-text="scope.row.is_recommend == '1' ? '已推荐' : '未推荐'"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="read_count"
              label="阅读数"
              align="center"
              sortable="custom"
            />
            <el-table-column
              prop="editor_name"
              label="最后更新人"
              align="center"
            />
            <el-table-column
              prop="modify_time"
              label="最后更新时间"
              align="center"
              sortable="custom"
            >
              <template slot-scope="scope">
                <span v-text="scope.row.modify_time.substr(0, 11)" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.is_show == 0"
                  type="text"
                  @click="issueArticle(scope.row)"
                >发布</el-button>
                <el-button
                  v-else
                  type="text"
                  @click="cancelArticle(scope.row)"
                >撤回</el-button>
                <el-button
                  type="text"
                  @click="updateArticle(scope.row.id)"
                >编辑</el-button>
                <el-button
                  style="color: #ff6c4c !important"
                  type="text"
                  @click="deleteArticle(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="filterObj.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="filterObj.limit"
        >
          <div class="chax">
            {{ filterObj.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ itemTotal }}条</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/toolbar/Checkbox.vue'
export default {
  name: 'DataManagement',
  components: {
    Checkbox
  },
  data() {
    return {
      optionsCascader: [
        {
          id: '',
          directory_name: '全部'
        }
      ],
      optionsContent: [
        {
          text: '全部',
          value: ''
        },
        {
          text: '图文',
          value: '1'
        },
        {
          text: '视频',
          value: '2'
        }
      ],
      optionsRecommend: [
        {
          text: '全部',
          value: ''
        },
        {
          text: '已推荐',
          value: '1'
        },
        {
          text: '未推荐',
          value: '0'
        }
      ],
      optionsShow: [
        {
          text: '全部',
          value: ''
        },
        {
          text: '已发布',
          value: '1'
        },
        {
          text: '未发布',
          value: '0'
        }
      ],
      time_frame: [],
      times: [
        {
          text: '通用',
          value: '1'
        },
        {
          text: '春季',
          value: '2'
        },
        {
          text: '暑假',
          value: '3'
        },
        {
          text: '秋季',
          value: '4'
        },
        {
          text: '寒假',
          value: '5'
        }
      ],
      filterObj: {
        p: 1,
        limit: 10,
        title: '',
        directory_id: '',
        is_recommend: '',
        is_show: '',
        type: '',
        time_frame: '',
        order_key: '',
        order_sort: ''
      },
      itemTotal: 0,
      itemList: []
    }
  },
  watch: {
    'filterObj.p': {
      handler: function() {
        this.getArticleList(this.filterObj)
      }
    },
    'filterObj.limit': {
      handler: function() {
        this.getArticleList(this.filterObj)
      }
    }
  },
  mounted() {
    this.getDirectoryListTree()
  },
  methods: {
    async getDirectoryListTree() {
      const ret = await this.$http.getDirectoryListTree()
      if (ret.code == 200) {
        this.optionsCascader = this.optionsCascader.concat(ret.data)
        this.getArticleList(this.filterObj)
      }
    },
    async getArticleList(filterObj) {
      const ret = await this.$http.getArticleList(filterObj)
      this.itemList = ret.data.list
      this.itemTotal = ret.data.count - 0
    },
    async articleRemove(id) {
      const ret = await this.$http.articleRemove({ id })
      if (ret.code == 200) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.getArticleList(this.filterObj)
      }
    },
    async articleIssue(id, is_show) {
      const ret = await this.$http.articleIssue({ id, is_show })
      if (ret.code == 200) {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.getArticleList(this.filterObj)
      }
    },
    changeDataType(val) {
      this.filterObj.directory_id = val[val.length - 1]
    },
    updateCheck(val) {
      this.time_frame = val
      this.filterObj.time_frame = val.join(',')
    },
    searchData() {
      this.getArticleList(this.filterObj)
    },
    handleSizeChange(val) {
      this.filterObj.limit = val
    },
    deleteArticle(item) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.articleRemove(item.id)
      })
    },
    issueArticle(item) {
      this.$confirm('确定发布吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.articleIssue(item.id, 1)
      })
    },
    cancelArticle(item) {
      this.$confirm('确定撤回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.articleIssue(item.id, 0)
      })
    },
    addArticle() {
      this.$router.push({
        path: 'dataManagementAdd'
      })
    },
    updateArticle(id) {
      this.$router.push({
        path: 'dataManagementAdd',
        query: { id }
      })
    },
    tableSort(val) {
      this.filterObj.order_key = val.prop
      this.filterObj.order_sort =
        val.order == 'ascending' ? '4' : val.order == 'descending' ? '3' : ''
      this.getArticleList(this.filterObj)
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  .table-filter {
    .add-data {
      padding-bottom: 40px;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 40px;
    }
  }
  .table-main {
    padding-top: 50px;
    .table-header {
      margin-bottom: 20px;
    }
  }
}

.el-button.el-button--primary {
  width: 90px;
  height: 40px;
}

.el-input {
  width: 180px;
}

.el-cascader {
  width: 180px;
}

.el-select {
  width: 180px;
}

.el-table {
  img {
    width: 100%;
  }
}

.el-button {
  &.el-button--text {
    color: $color_blue;
    font-size: 14px;
  }
}
</style>
